import { UserInPing } from '@reach/interfaces/user/user-in-ping';

import { ReachSession } from '~/session/types';

export function apiUserParser(user: UserInPing | null): ReachSession | null {
	if (!user) {
		return null;
	}

	return {
		userId: user.privateId,
		username: user.username,
		adminRole: user.adminFeatureFlags,
		adminToolsFlags: user.adminToolsFlags || [],
	};
}
